import React, { useEffect, useState, useRef } from "react";
import { Dropdown } from "../components/Dropdown";
import { Footer } from "../components/Footer";
import { HeaderWrapper } from "../components/HeaderWrapper";
import { Paragraph } from "../components/Paragraph";
import { ShortAnswer } from "../components/ShortAnswer";
import { SubmitButton } from "../components/SubmitButton";
import { liff } from "@line/liff";
import "./style.css";
import RootLayout from "layouts/RootLayout";
import { Dialog, DialogTitle } from "@mui/material";


const LIFF_ID = process.env.REACT_APP_FORM_LIFF_ID;
const consultNotifyUrl = process.env.REACT_APP_FORM_URL;
//EUcare Jake.chen
// const updateProfileUrl = 'https://script.google.com/macros/s/AKfycbzQRGTNUqI8QBkYt-5C5smS5czCK8OMY7iAJwSfSmMHQjeQQdA-NNLG7J_2EEKHcjIt/exec'
// twdata puppy
const updateProfileUrl = 'https://script.google.com/macros/s/AKfycbwJ1cL-QqTZNLvD2H36QRrf2dMeWUH4gtMTOuiIm3o26NUf3hXvNG3CbS7g-e4vIbpE7g/exec'

const FETCH_SUCCESS = 200;

const initializeLIFF = async () => {
    try {
        await liff.init({ liffId: LIFF_ID });

        if (!liff.isLoggedIn()) {
            liff.login();
        }

        // if (!liff.isInClient()) {
        //     alert('諮詢表單請使用手機 LINE APP 開啟填寫，如您有緊急需求請撥打 119 或可參考下列就醫資訊詢問');
        //     window.location.href = "https://klchb.gocare.tw/clinicList";   // dev
        //     return null;
        // }
        return liff;
    } catch (error: unknown) {
        console.error('初始化 liff 時出錯：', error);
    }
};

const sendLiffMessage = async (liffClient, sendMessage, topicSelected) => {
    try {
        const profile = await liffClient.getProfile();
        let message: string;
        switch (topicSelected) {
            case '新生兒照護':
                message = `請協助諮詢回覆-新生兒照護`;
                break;
            case '呼吸道症狀':
                message = `請協助諮詢回覆-呼吸道症狀`;
                break;
            case '腹瀉嘔吐':
                message = `請協助諮詢回覆-腹瀉嘔吐`;
                break;
            case '腹痛':
                message = `請協助諮詢回覆-腹痛`;
                break;
            case '外傷處理':
                message = `請協助諮詢回覆-外傷處理`;
                break;
            default:
                message = `請協助諮詢回覆`;
        }

        // 透過 LIFF SDK 發送訊息給用戶
        await liffClient.sendMessages([{
            type: 'text',
            text: sendMessage
        }]);

        await liffClient.sendMessages([{
            type: 'text',
            text: message
        }]);

    } catch (error: unknown) {
        console.error('Error initializing liff or sending message: ', error);
        alert('因網路問題，無法送出諮詢，請稍後再試或有緊急需求請撥打119!!!');
    }
}

export const ConsultForm = (): JSX.Element => {
    const [liffClientObject, setLiffClientObject] = useState(null);
    // name of the user
    const [name, setName] = useState("");
    const [address, setAddress] = useState("");
    const [phone, setPhone] = useState("");
    const [topicSelected, setTopicSelected] = useState("");
    const [contentText, setContentText] = useState("");
    const [loading, setLoading] = useState(true);
    const [selectedKid, setselectedKid] = useState(0);
    const [kidData, setKidData] = useState([{ name: '', age: '', weight: '', primary_medical: '' }]);
    const [inputKidData, setInputKidData] = useState({ name: '', age: '', weight: '', primary_medical: '' })
    const [profileHaveData, setProfileHaveData] = useState(false);

    const formRef = useRef<HTMLFormElement>(null);
    const userId = liffClientObject?.getContext()?.userId
    const accessToken = liffClientObject?.getAccessToken()

    useEffect(() => {
        const initialize = async () => {
            const liffObject = await initializeLIFF();
            setLiffClientObject(liffObject);
        };
        initialize()
    }, []);



    useEffect(() => {

        if (userId === undefined) return
        if (accessToken === undefined) return

        const getProfileUrl = `https://script.google.com/macros/s/AKfycbwJ1cL-QqTZNLvD2H36QRrf2dMeWUH4gtMTOuiIm3o26NUf3hXvNG3CbS7g-e4vIbpE7g/exec?userId=${userId}&accessToken=${accessToken}`;

        fetch(getProfileUrl)
            .then(response => response.json())
            .then(data => {
                //有填過基本資料
                if (data.status_code === FETCH_SUCCESS) {
                    console.log(data)
                    setName(data.data.name);
                    setPhone(data.data.phone);
                    setAddress(data.data.address);
                    setKidData(data.data.childes);
                    setselectedKid(1);
                    setInputKidData(data.data.childes[0])
                    setProfileHaveData(true);
                }
                setLoading(false);
            });

    }, [userId, accessToken])



    const validate = () => {
        const form = formRef.current;
        if (form?.checkValidity()) {
            return true;
        } else {
            return false;
        }
    };

    const handleSelectKids = (e) => {
        const selectedValue = e.target.value
        setselectedKid(selectedValue);

        if (selectedValue === "請選擇") {
            setselectedKid(1);
        } else {
            const selectedKidIndex = kidData.findIndex(kid => kid.name === selectedValue);
            if (selectedKidIndex !== -1) {
                setInputKidData(kidData[selectedKidIndex]);
            } else {
                setselectedKid(1);
            }
        }
    };

    const handleKidsInput = (e: React.ChangeEvent<HTMLInputElement>, type: string) => {
        const temp = { ...inputKidData };
        temp[type] = e.target.value;
        setInputKidData(temp);
    }


    const handleSubmit = async (e: React.FormEvent) => {
        setLoading(true);
        e.preventDefault();
        if (validate()) {
            if (liffClientObject) {
                const sendMessage = `本次諮詢填寫內容：\n姓名：${name}\n聯絡電話：${phone}\n地址：${address}\n孩童姓名：${inputKidData.name}\n年齡：${inputKidData.age}\n體重：${inputKidData.weight}\n平時主要就醫診所：${inputKidData.primary_medical}\n諮詢問題：${topicSelected}\n補充說明：${contentText}`;
                await sendLiffMessage(liffClientObject, sendMessage, topicSelected);
                const getProfile = await liffClientObject?.getProfile()
                const lineName = getProfile.displayName || 'Guest';
                fetch(consultNotifyUrl, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'text/plain;charset=utf-8',
                    },
                    body: JSON.stringify({
                        line_name: lineName,
                        name: name,
                        phone: phone,
                        address: address,
                        child_name: inputKidData.name,
                        year_selected: inputKidData.age,
                        weight: inputKidData.weight,
                        primary_medical: inputKidData.primary_medical,
                        topic_selected: topicSelected,
                        content_text: contentText
                    })
                }).catch((error) => {
                    // 顯示錯誤訊息提示，跳出訊息內容：因網路問題，無法送出諮詢，請稍後再試或有緊急需求請撥打119
                    alert('因網路問題，無法送出諮詢，請稍後再試或有緊急需求請撥打119!!');
                });
                if (!profileHaveData) {
                    await fetch(updateProfileUrl, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'text/plain;charset=utf-8',
                        },
                        body: JSON.stringify({
                            accessToken: accessToken,
                            profile: await liffClientObject.getProfile(),
                            userId: userId,
                            name: name,
                            phone: phone,
                            address: address,
                            child_number: 1,
                            childes: [inputKidData]
                        })
                    })
                }
                setProfileHaveData(true);

            } else {
                console.error('LIFF client object is not initialized');
                alert('因網路問題，無法送出諮詢，請稍後再試或有緊急需求請撥打119!');
            }
            liff.closeWindow();
        }
    };

    const kidDropdown = kidData.map(kid => kid.name);

    return (
        <RootLayout title="我要諮詢">
            <form onSubmit={handleSubmit} ref={formRef}>
                <div style={{ display: 'flex', flexDirection: 'column', padding: '20px 44px', gap: '16px' }}>
                    <ShortAnswer className="" hasDiv={false} text="姓　　名："
                        dataInput={name}
                        onChange={(e) => {
                            setName(e.target.value);
                        }}
                    />
                    <ShortAnswer className="" hasDiv={false} text="聯絡電話："
                        dataInput={phone}
                        onChange={(e) => {
                            setPhone(e.target.value);
                        }}
                    />
                    <ShortAnswer className="" hasDiv={false} text="地　　址："
                        dataInput={address}
                        onChange={(e) => {
                            setAddress(e.target.value);
                        }}
                    />

                    {profileHaveData &&
                        <Dropdown
                            className=""
                            frame="/img/frame.svg"
                            frameClassName="dropdown-2"
                            hasDiv={false}
                            options={kidDropdown}
                            dataSelected={String(selectedKid)}
                            onChange={handleSelectKids}
                            text="選擇孩子："
                        />
                    }


                    <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                        <ShortAnswer
                            className=""
                            hasDiv={false}
                            text='孩子姓名：'
                            dataInput={inputKidData.name}
                            onChange={(e) => handleKidsInput(e, 'name')}
                        />
                        <ShortAnswer
                            className=""
                            hasDiv={false}
                            text="年　　齡："
                            dataInput={inputKidData.age}
                            onChange={(e) => handleKidsInput(e, 'age')}
                        />
                        <ShortAnswer
                            className=""
                            hasDiv={false}
                            text="體　　重："
                            dataInput={inputKidData.weight}
                            onChange={(e) => handleKidsInput(e, 'weight')}
                        />
                        <ShortAnswer
                            className=""
                            hasDiv={false}
                            text="平時主要就醫診所機構："
                            dataInput={inputKidData.primary_medical}

                            onChange={(e) => handleKidsInput(e, 'primary_medical')}
                        />
                    </div>

                    <Dropdown
                        className=""
                        frame="/img/frame-1.svg"
                        frameClassName="dropdown-2"
                        hasDiv={false}
                        options={["新生兒照護", "發燒", "呼吸道疾患", "腹痛", "腹瀉嘔吐", "腸病毒", "外傷處理", "其他問題"]}
                        dataSelected={topicSelected}
                        onChange={(e) => {
                            setTopicSelected(e.target.value);
                        }}
                        text="諮詢問題："
                    />

                    <Paragraph className="" hasDiv={false} text="補充說明："
                        dataText={contentText}
                        onChange={(e) => {
                            setContentText(e.target.value);
                        }}
                    />
                    <SubmitButton className="profileSubmitbtn" text="寫好送出" loading={loading} />
                </div>
            </form>
            <Dialog open={loading}>
                <DialogTitle >
                    資料存取中...
                </DialogTitle>
            </Dialog>
        </RootLayout>
    );
};